import type { DispatcherPermissionName, DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import { Role } from "@/constants/navigation";

export enum DispatcherGroup {
  Accounting = "accounting",
  Booking = "booking",
  Hiring = "hiring",
  Operational = "operational",
}

export const RoleGroupMap: Partial<Record<Role, DispatcherGroup>> = {
  [Role.booking]: DispatcherGroup.Booking,
  [Role.hr]: DispatcherGroup.Hiring,
  [Role.operation]: DispatcherGroup.Operational,
  [Role.accounting]: DispatcherGroup.Accounting,
};

export interface DispatcherGroupPermission {
  key: DispatcherPermissionValue;
  name: DispatcherPermissionName;
}

export type DispatcherGroups = Record<DispatcherGroup, DispatcherGroupPermission[]>;
